<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{ $t('Aging-Report') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" label=" Ara"
                append-icon="search"></v-text-field>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>




          <v-container fluid>
            <v-layout row wrap>

              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat>
                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex pb-3 xs12 sm12 md12>
                        <v-card flat>
                          <v-layout row wrap>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp :etiket="'Tarih'" :detaygizle="false"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="Rapor.Tarih" v-model="Rapor.Tarih"></tarihcomp>
                            </v-flex>


                            <v-flex pt-2>
                              <v-layout align-center="">
                                <div v-if="load1">
                                  <v-btn color="info" @click="getList()" fab small="" dark>
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </div>
                                <div v-if="progress">
                                  <v-layout align-center="">
                                    <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                                  </v-layout>
                                </div>

                                <v-badge color="white" :overlap="true">
                                  <template v-slot:badge>
                                    <v-icon v-if="filtrevarmi" large color="green">
                                      check_circle_outline </v-icon>
                                  </template>

                                  <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                                    @click="filtrele()" color="info" fab dark>
                                    <v-icon>filter_list</v-icon>
                                  </v-btn>
                                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                    <span>{{$t('Add-Search-Filter')}}</span>
                                  </v-tooltip>



                                </v-badge>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                  </v-form>

                </v-card>
              </v-flex>


              <v-flex v-if="kayitvarmi" xs12 sm12 md12 pb-3>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>

                        <v-flex ma-2 xs12 sm12 md12>
                          <v-layout align-start="" justify-start="" fill-height="">
                            <span class="subheading black--text font-weight-">
                              Detaylar
                            </span>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12>
                          <v-card flat>
                            <v-data-table :headers="headersbaslik" :rows-per-page-items=[20,50,100,200]
                              :items="itemssatis" :search="searchsatilanbilet">
                              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                              <template slot="items" slot-scope="props">
                                <tr item>

                                  <td v-for="kayit in props.item" :key="kayit.id" class="text-xs-center"> {{kayit }}
                                  </td>


                                </tr>
                              </template>
                              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                              </v-alert>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>


              <v-flex v-if="kayitvarmi" xs12 sm12 md12 pb-3>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>

                        <v-flex ma-2 xs12 sm12 md12>
                          <v-layout align-start="" justify-start="" fill-height="">
                            <span class="subheading black--text font-weight-">
                              {{ $t('General-Totals') }}
                            </span>
                          </v-layout>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12>
                          <v-card flat>
                            <v-data-table hide-actions="" :headers="headersbaslik" :rows-per-page-items=[1]
                              :items="itemssatistoplam">

                              <template slot="items" slot-scope="props">
                                <tr item>
                                  <td v-for="kayit in props.item" :key="kayit.id" v-if="kayit=='-'"
                                    class="text-xs-center"> {{kayit }} </td>

                                  <td v-for="kayit in props.item" :key="kayit.id" v-if="kayit!='-'"
                                    class="text-xs-right"> {{kayit | moneyformat }} </td>
                                </tr>
                              </template>
                              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                              </v-alert>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
          
                            <v-flex xs12 sm12 md12>

                                <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.Cari.Kod" :loading="loading" 
                                  v-model="Rapor.Cari.Kod"></cariaracomp>
                            </v-flex>
                           <v-flex xs12 sm12 md12 style="margin-bottom:-15px">
                              <analizcomp :etiket="$t('Analysis-Code')" v-model="Rapor.AnalizKodu"></analizcomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select :items="hesapgrubu" hide-details="" v-model="Rapor.Gruplar"
                                :label="$t('Account-Group-Requested')" multiple item-text="Title" item-value="Kod"
                                max-height="400">
                              </v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-select :items="hesapgrubu" hide-details="" v-model="Rapor.NoGruplar"
                                :label="$t('Account-Group-Not-Requested')" multiple item-text="Title" item-value="Kod"
                                max-height="400">
                              </v-select>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field :label="$t('Number-of-Days')" mask="######" v-model="Rapor.GunSayi"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field :label="$t('Number-of-Periods')" mask="##" v-model="Rapor.DonemSayisi"></v-text-field>
                            </v-flex>

                   

                            <v-flex xs12 sm6 md6>
                              <v-radio-group v-model="Rapor.RaporTip" :label="$t('Report-Type')" column>
                                <v-radio :label="$t('On-Alternate-Days')" value='0'></v-radio>
                                <v-radio :label="$t('Monthly')" value='1'></v-radio>
                                <v-radio :label="$t('15-day')" value='2'></v-radio>
                                <v-radio :label="$t('Weekly')" value='3'></v-radio>
                              </v-radio-group>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.IleriGeri" :label="$t('Age-Retrospectively')" hide-details="">
                              </v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.CoperEvrak" label="Coper faturalanmamışları gösterme" hide-details=""></v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>


                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import analizcomp from '@/components/app/bilet/partpage/analizcomp'

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        referansitems: [],
        search: '',
        searchsatilanbilet: null,
        tarihitems: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010,
          2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028,
          2029, 2030
        ],

        kayitvarmi: false,
        headersbaslik: [],
        itemssatistoplam: [],
        genelToplamlar: {
          ToplamAdatAlacak: 0,
          ToplamAdatBorc: 0,
          ToplamGun: 0,
          VadeFarki: 0
        },


        hesapgrubu: [],
        nohesapgrubu: [],


        Rapor: {
          Tarih: null,
          SirketKodu: null,
          Cari: {
            Kod: null,
          },
          Gruplar: [],
          NoGruplar: [],
          GunSayi: null,
          RaporTip: '0', // 0 : Gun Aralıklı, 1 : aylık , 2 : 15 gunluk : 3 : Haftalık
          DonemSayisi: null,
          IleriGeri: false, // false : Ileri , true : Geri
          CoperEvrak: false,
          AnalizKodu:null
        },



        valid: true,
        tumsirketler: '',
        loadingana: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        statecari: [],
        searchcari: '',
        statecariana: [],
        searchcariana: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],

        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
     beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

       this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
          this.Rapor.Yil = helpers.getYear();

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
      this.nohesapgrubu = response.body

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
    //   headers: {
    //     'Authorization': 'Bearer ' + auth.getAuthHeader()
    //   }
    // }).then((response) => {
    //   this.referansitems = response.body
    // }, (response) => {
    //   if (response.status === 0) {
    //     this.text1 = 'Service Unavailable'
    //     this.snackbar = true
    //   } else {
    //     this.text1 = 'Service Unavailable'
    //     this.snackbar = true
    //   }
    // })




    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      yuzdeinput,
      yetkidialog,
      cariaracomp,
      analizcomp
    },
    watch: {
    },
    methods: {
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      tarihformat
    }
  }

  function tarihformat(t) {

    if (t != '0001-01-01T00:00:00' && t != '' && t != null) {
      var date = new Date(t);
      var fulldate = date.toLocaleDateString("tr-TR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return fulldate;
    } else {
      return null
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgrubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {

    this.filtrevarmi = false
    this.dialogfiltre = false

    this.Rapor.SirketKodu = null
    this.Rapor.AnaHesap = null
    this.Rapor.Cari.Kod = null
    this.Rapor.HesapGrubu = []
    this.Rapor.GunSayi = null
    this.Rapor.YillikFaiz = 0
    this.Rapor.AnalizKodu = null
    this.tumsirketler = ''

  }

  function getList() {

    if (this.$refs.formgunluksatis.validate()) {
      this.kayitvarmi = false
      this.progress = true
      this.load1 = false
      this.headersbaslik = []
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http.post(auth.API_URL + 'api/Report/AgingReport', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {


        this.kayitvarmi = true

        var heeeder = [];

        var ind = {
          text: this.$t('Accound-Code'),
          value: 'aCari',
        }
        heeeder.push(ind)
        var ind = {
          text: this.$t('Account-Name'),
          value: 'bUnvan',
        }
        heeeder.push(ind)
        var ind = {
          text: 'Önceki',
          value: 'cOncekiDonem',
        }
        heeeder.push(ind)


        //tekrar eden alanları dinamik olarak alalım

        if (response.body.DetayList.length>0) {

        var ilk = response.body.DetayList[0].Donemler

        Object.keys(ilk).forEach(function (key) {

          var tarih = tarihformat(ilk[key].BaslangicTarih) + '-' + tarihformat(ilk[key].BitisTarih)

          var ind = {
            text: tarih,
            value: 'd' + key
          }
          heeeder.push(ind)

        });

        }

        var ind = {
          text: 'İleri',
          value: 'eIleriDonem',
        }
        heeeder.push(ind)
        var ind = {
          text: 'Toplam',
          value: 'fToplam',
        }
        heeeder.push(ind)
        this.headersbaslik = heeeder



        this.itemssatis = []

        response.body.DetayList.forEach(element => {
          var object = {}

          object["aCari"] = element.Cari.Kod
          object['bUnvan'] = element.Cari.Unvan
          object['cOncekiDonem'] = element.OncekiDonem


          Object.keys(element.Donemler).forEach(function (key) {
            object['d' + key] = element.Donemler[key].Tutar
          });

          object['eIleriTarih'] = element.IleriDonem
          object['fToplam'] = element.Toplam

          this.itemssatis.push(object)
        });



        this.itemssatistoplam = []
        var object = {}
        object["aCari"] = '-'
        object['bUnvan'] = '-'
        object['cOncekiDonem'] = response.body.GenelOncekiDonem

        Object.keys(response.body.GenelDonemler).forEach(function (key) {
          object['d' + key] = response.body.GenelDonemler[key].Tutar
        });
        object['eIleriTarih'] = response.body.GenelIleriDonem
        object['fToplam'] = response.body.GenelToplam

        this.itemssatistoplam.push(object)

        this.progress = false
        this.load1 = true

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-AgingReport'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable-AgingReport'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {

      this.progress = true
      this.load1 = false
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/Report/AgingReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {


          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "YaslandirmaRaporu.html";
          link.click();



        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {

      this.progress = true
      this.load1 = false
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/Report/AgingReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {


          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "YaslandirmaRaporu.xlsx";
          link.click();





        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }
  }


  function beforeMount() {



  }
</script>
<style>
</style>